import React from 'react'
import {Icon} from '@chakra-ui/react'

const BenefitDeliveryIcon = (props) => {
    return (
        <Icon viewBox="0 0 16 16" fill="none" {...props}>
            <path
                d="M3.52712 1.59967H6.08701C6.95963 1.59967 7.39595 1.59967 7.70181 1.8219C7.8006 1.89366 7.88747 1.98054 7.95924 2.07932C8.18146 2.38518 8.18146 2.8215 8.18146 3.69412V12.6537H1.19995"
                stroke="currentColor"
                strokeWidth="1.2"
                strokeLinecap="round"
            />
            <path
                d="M8.1814 4.50922H10.0989C11.7344 4.50922 12.5521 4.50922 13.1461 4.91542C13.3385 5.04699 13.51 5.20671 13.6549 5.38924C14.1024 5.95279 14.1607 6.76842 14.2772 8.39967L14.4208 10.4106C14.4872 11.3391 14.5203 11.8033 14.3012 12.1338C14.2306 12.2402 14.1431 12.3342 14.042 12.4122C13.728 12.6543 13.2625 12.6543 12.3317 12.6543H8.1814V4.50922Z"
                stroke="currentColor"
                strokeWidth="1.2"
            />
            <circle
                cx="11.3812"
                cy="12.9452"
                r="1.45448"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.2"
            />
            <circle
                cx="4.98134"
                cy="12.9452"
                r="1.45448"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.2"
            />
            <path
                d="M13.9993 8.58121L13.1848 8.58121C12.3121 8.58121 11.8758 8.58121 11.57 8.35898C11.4712 8.28721 11.3843 8.20034 11.3125 8.10156C11.0903 7.79569 11.0903 7.35932 11.0903 6.48656C11.0903 5.44125 11.0903 4.50866 11.0903 4.50866"
                stroke="currentColor"
                strokeWidth="1.2"
            />
            <path
                d="M5.85449 8.58121L1.78195 8.58121"
                stroke="currentColor"
                strokeWidth="1.2"
                strokeLinecap="round"
            />
            <path
                opacity="0.1"
                d="M12.8359 8.58121L8.76339 8.58121"
                stroke="currentColor"
                strokeWidth="1.2"
                strokeLinecap="round"
            />
            <path
                opacity="0.1"
                d="M10.7415 6.48676L8.76336 6.48676"
                stroke="currentColor"
                strokeWidth="1.2"
                strokeLinecap="round"
            />
            <path
                opacity="0.1"
                d="M14.2322 10.6757L8.76333 10.6757"
                stroke="currentColor"
                strokeWidth="1.2"
                strokeLinecap="round"
            />
            <path
                d="M5.85449 5.09045L2.94553 5.09045"
                stroke="currentColor"
                strokeWidth="1.2"
                strokeLinecap="round"
            />
        </Icon>
    )
}

export default BenefitDeliveryIcon
